import React, { Component, Fragment } from 'react'
import ReactGA from 'react-ga'
import { withTranslation, Trans } from 'react-i18next'
import { Button, Transition } from 'semantic-ui-react'
import { inject, observer } from 'mobx-react'

@inject('user', 'appState')
@observer
class BannerCrosschq extends Component {
  constructor(props) {
    super(props)
    this.state = {
      sent: false
    }
  }

  send(action = '') {
    ReactGA.event({
      category: 'Crosschq Lead',
      action,
      label: 'Survey Header'
    })
  }

  sendContactMsg = async () => {
    this.send('opt-in')
    await this.props.user.interestedInProduct()
    this.setState({ sent: true })
  }

  closeBanner = () => {
    this.send('close')
    this.props.appState.setShowBanner(false)
  }

  render() {
    const { t, appState } = this.props
    const { sent } = this.state

    return (
      <Transition animation='fade' visible={appState.shouldDisplayBanner}>
        <div>
          <div className='flex no-wrap banner-container'>
            <div className='banner-content'>
              {sent ? (
                <Fragment>
                  <span>{t('Thank you for your interest!')}</span>{' '}
                  {t('A Crosschq representative will be in touch.')}
                </Fragment>
              ) : (
                <Fragment>
                  <span>{t('Would you like to use Crosschq at your company?')}</span>
                  <Trans>
                    <span>
                      <a onClick={this.sendContactMsg} className='survey-click-here'>
                        Click here
                      </a>
                    </span>
                    to request more information.
                  </Trans>
                </Fragment>
              )}
            </div>
            <Button
              onClick={this.closeBanner}
              circular
              basic
              className='close-button'
            >
              <h5>&times;</h5>
            </Button>
          </div>
        </div>
      </Transition>
    )
  }
}

export default withTranslation()(BannerCrosschq)
